import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-3" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center px-2 py-1 rounded border border-[#9e9eb7] bg-[#e2e2e9] text-sm text-[#16161d]"
}

import { storeToRefs } from 'pinia'
import { mdiHistory } from '@mdi/js'
import { useHandoverStore } from '@/pinia-store/useHandoverStore'
import HandoverFilters from './HandoverFilters.vue'
import type { HandoverFilterValues } from './handoverFilters.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverFilterBar',
  emits: ["viewHistory"],
  setup(__props) {



const handoverStore = useHandoverStore()
const { totalPending } = storeToRefs(handoverStore)

const applyFilters = (filters: HandoverFilterValues) => {
  handoverStore.setFilters(filters)
  handoverStore.fetchPendingApprovals(1)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HandoverFilters, {
      "model-value": _unref(handoverStore).filters,
      context: "pending",
      "onUpdate:modelValue": applyFilters
    }, null, 8, ["model-value"]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(totalPending) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(totalPending)) + " aprovações pendentes ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "ml-auto flex items-center gap-1 px-1 py-3 rounded text-sm font-bold text-[#2f7f91] hover:bg-gray-50",
        "data-testid": "handover-view-history-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewHistory')))
      }, [
        _createVNode(_component_v_icon, {
          size: "20",
          color: "#2f7f91",
          icon: _unref(mdiHistory)
        }, null, 8, ["icon"]),
        _createTextVNode(" Ver histórico ")
      ])
    ])
  ]))
}
}

})